module.exports = {
  preview: '@cm-preview',
  context: {
    masthead: '@masthead',
    footer: '@footer',
    hero: '@interior-hero',
    cta: {
      class: 'no-media',
      heading: {
        text: 'Join Us',
        tag: 'h2',
        class: 'heading-4'
      },
      shortDescription: {
        text: 'Explore job opportunities with purpose at Adjoin',
        tag: 'p',
        class: 'heading-2'
      },
      button: {
        text: 'Donate',
        url: 'https://google.com',
        class: 'secondary'
      }
    },
    richText: '@cm-rich-text',
    buttonGroup: '@cm-button-group',
    timeline: '@cm-timeline',
    featuredPages: '@featured-pages',
    featuredPagesStaggered: '@featured-pages--staggered',
    featuredStories: '@featured-stories',
    iconGroup: '@icon-group',
    team: '@cm-team',
    image: '@image',
    multipleImages: '@cm-multiple-images',
    video: '@video',
    videoHasDescription: '@video--has-description',
    embed: '@cm-embed',
    blockquote: '@blockquote',
    heading: '@cm-heading'
  }
}
